/** @jsxImportSource @emotion/react */

import { FC } from 'react'
import { Field, useFormState } from 'react-final-form'
import { FormControlLabel } from '@mui/material'
import Checkbox from '@mui/material/Checkbox'
import { OnChange } from 'react-final-form-listeners'
import { InputField } from 'components/Input'
import { FormState } from '../consts'
import * as formClasses from '../styles'
import * as classes from './styles'

const NUMERIC_VALUE_REGEX = /^-?(?:0|[1-9]\d*)(?:\.\d+)?$/

export const validateRequiredNumeric = (value?: string | number) => {
  if (value === undefined || value === null || value === '') {
    return 'Required'
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? undefined : 'Must be a number'
  }

  return NUMERIC_VALUE_REGEX.test(value) ? undefined : 'Must be a number'
}

export const validateRequiredNonZeroNumeric = (value?: string | number) => {
  const error = validateRequiredNumeric(value)

  if (error) {
    return error
  }

  return Number(value) === 0 ? 'Denominator cannot be 0' : undefined
}

type Props = {
  onAnswerChange: () => void
}

export const NumericResponseAnswer: FC<Props> = ({ onAnswerChange }) => {
  const { values } = useFormState<FormState, Partial<FormState>>()
  const isFraction = values.numericResponseAnswer?.isFraction

  return (
    <>
      <div css={formClasses.title}>Answer</div>
      <OnChange name="numericResponseAnswer">{() => onAnswerChange()}</OnChange>
      <Field name="numericResponseAnswer.isFraction" type="checkbox">
        {({ input }) => (
          <FormControlLabel
            label="Fraction Answer"
            control={<Checkbox {...input} />}
            css={[formClasses.checkbox, classes.checkbox]}
          />
        )}
      </Field>
      {isFraction ? (
        <div css={classes.fractionFields}>
          <InputField
            name="numericResponseAnswer.numeratorValue"
            validate={validateRequiredNumeric}
            label="Numerator"
            placeholder="Enter Numerator"
            fullWidth
          />
          <InputField
            name="numericResponseAnswer.denominatorValue"
            validate={validateRequiredNonZeroNumeric}
            label="Denominator"
            placeholder="Enter Denominator"
            fullWidth
          />
        </div>
      ) : (
        <InputField
          name="numericResponseAnswer.value"
          validate={validateRequiredNumeric}
          label="Answer"
          placeholder="Enter Answer"
          fullWidth
        />
      )}
    </>
  )
}
